module.exports = __webpack_public_path__ + "img/2.62c9ad9f.png";